import { Injectable } from "@angular/core";
import { HttpService } from "@planard/@core/backend/api/http.service";
import { Observable } from "rxjs";
import { ProductCost } from "@planard/@core/entities/productCost";

@Injectable()
export class ProductCostApi {
  private readonly apiController: string = "productCostPlan";

  constructor(private api: HttpService) {}

  listPrices<T>(
    scenarioId: number,
    approveRequestId?: number
  ): Observable<any> {
    const endpointUrl = approveRequestId
      ? `${this.apiController}/listPrices/${scenarioId}/?approveRequestId=${approveRequestId}`
      : `${this.apiController}/listPrices/${scenarioId}`;
    return this.api.get(endpointUrl);
  }

  update<T>(plan: ProductCost): Observable<any> {
    return this.api.post(`${this.apiController}/update`, plan);
  }
}
